import { useEffect, useMemo, useRef } from 'react';

import { resolvePageTitle, type ResolvePageTitleOptions } from './resolvePageTitle';

export const useUnifiedDocumentTitle = (
  pageTitle: string | null | undefined,
  siteTitle: string | null | undefined,
  options: ResolvePageTitleOptions = {},
): void => {
  const initialTitleRef = useRef<string | null>(
    typeof document !== 'undefined' ? document.title : null,
  );

  const resolvedTitle = useMemo(
    () => resolvePageTitle(pageTitle, siteTitle, options),
    [pageTitle, siteTitle, options],
  );

  useEffect(() => {
    if (typeof document === 'undefined') {
      return;
    }
    document.title = resolvedTitle;
  }, [resolvedTitle]);

  useEffect(() => {
    return () => {
      if (typeof document === 'undefined') {
        return;
      }
      if (initialTitleRef.current !== null) {
        document.title = initialTitleRef.current;
      }
    };
  }, []);
};

export default useUnifiedDocumentTitle;
